export const TIPI_STRUTTURA = [
  "RSA",
  "Casa di Riposo",
  "Comunità Alloggio",
  "Centro Diurno",
  "Residenza Protetta",
  "Hospice",
  "Altro",
];

export function coerceTipoStruttura(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const match = TIPI_STRUTTURA.find((tipo) => tipo.toLowerCase() === raw.toLowerCase());
  return match || "";
}
